import { useShowContext } from 'framework/show';
import { SetStaffingProjectData, StaffingAssignmentSlot, StaffingProjectData } from 'domain/shared/staffing';
import { useState } from 'react';
import { PlusIcon, Tooltip } from 'framework/ui/mui-builder';
import IconButton from '@mui/material/IconButton';
import CreateStaffingAssignmentModal from './CreateStaffingAssignmentModal';
import { AssignmentType } from 'domain/shared/assignment';

const CreateAssignmentAction = ({
  projectData,
  setProjectData,
  isPlanned,
  disabled,
}: {
  projectData: StaffingProjectData;
  setProjectData?: SetStaffingProjectData;
  isPlanned?: boolean;
  disabled?: boolean;
}) => {
  const { data } = useShowContext();
  const slot = data.getData() as unknown as StaffingAssignmentSlot;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={`Create ${isPlanned ? 'planned' : ''} assignment`}>
        <span>
          <IconButton onClick={() => setOpen(true)} sx={{ p: 0 }} disabled={disabled}>
            <PlusIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </span>
      </Tooltip>
      <CreateStaffingAssignmentModal
        open={open}
        setOpen={setOpen}
        isPlanned={isPlanned}
        projectData={projectData}
        setProjectData={setProjectData}
        initialData={{
          assignmentType: AssignmentType.INDIVIDUAL_ASSIGNMENT,
          slotId: slot.id,
          membershipRole: slot.requiredRole,
          positionId: slot.positionId,
          technologyId: slot.technologyId,
          competencyLevel: slot.competencyLevel,
        }}
      />
    </>
  );
};
export default CreateAssignmentAction;
